import nonDisruptingError from '../error/non_disrupting_error';
import { logGoogleAnalyticsEvent } from '../logging/logger';
import { NO_GOOGLE_ANALYTICS_OBJECT } from '../../_constants/errors_messages';

const gaSend = (...args) => {
    if (location.href.indexOf('disableGoogle=1') === -1) {
        if (window.gtag) {
            logGoogleAnalyticsEvent(...args);
            window.gtag(...args);
        } else {
            nonDisruptingError(NO_GOOGLE_ANALYTICS_OBJECT);
        }
    }
};

const setBehaviourEvent = args => gaSend('event', args.action, {
    event_category: args.category,
    event_label: args.label,
    value: args.value,
    non_interaction: args.nonInteraction,
    transport: args.beforeUnload ? 'beacon' : undefined,
});

const setSponsoredBehaviourEvent = args => gaSend('event', args.action, {
    event_category: args.category,
    event_label: args.label,
    value: args.value,
    spinach_id: args.spinach_id,
    sponsored_product_details: args.sponsored_product_details || undefined,
    sposored_product_brand: args.sposored_product_brand || undefined,
    sposored_product_model: args.sposored_product_model || undefined,
    sposored_product_dimensions: args.sposored_product_dimensions || undefined,
    sposored_product_state: args.sposored_product_state || undefined,
});

const sendPageView = () =>
    gaSend('config', window.GaMeasurementId);

const setPage = page =>
    gaSend('set', { page });

export {
    setBehaviourEvent,
    setSponsoredBehaviourEvent,
    sendPageView,
    setPage
};
